import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { storageBrowserApi } from "../api/storageBrowserApi";

export const useBucketsQuery = () => {
  return useQuery({
    queryKey: ["storage-buckets"],

    queryFn: () => storageBrowserApi.fetchBuckets(),
  });
};

export const useObjectsQuery = (bucket: string, prefix: string) => {
  return useQuery({
    queryKey: ["storage-objects", bucket, prefix],

    queryFn: () => storageBrowserApi.fetchObjects(bucket, prefix),

    enabled: !!bucket,
  });
};

export const useDeleteObject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ bucket, key }: { bucket: string; key: string }) =>
      storageBrowserApi.deleteObject(bucket, key),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["storage-objects"] });
    },
  });
};

export const useDeleteRecursive = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ bucket, prefix }: { bucket: string; prefix: string }) =>
      storageBrowserApi.deleteRecursive(bucket, prefix),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["storage-objects"] });
    },
  });
};

export const useCreateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ bucket, path }: { bucket: string; path: string }) =>
      storageBrowserApi.createFolder(bucket, path),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["storage-objects"] });
    },
  });
};

export const useUploadFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      bucket,

      prefix,

      file,
    }: {
      bucket: string;

      prefix: string;

      file: File;
    }) => storageBrowserApi.uploadFile(bucket, prefix, file),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["storage-objects"] });
    },
  });
};
